export default [
    {
        path: '/issues',
        name: 'issues',
        meta: {
            isSection: true
        },
        component: () => import('@/views/issue-list/index.vue')
    },
    {
        path: '/issues/add',
        component: () => import('@/components/yuri-submenu/index.vue'),
        children: [
            {
                path: '',
                name: 'issues_add',
                component: () => import('@/views/issue-details/index.vue')
            },
            {
                path: 'view',
                name: 'issues_add_view',
                component: () => import('@/components/dynamic-view/index.vue'),
                props: route => ({ view: route.query.view, id: route.query.id }),
                meta: {
                    isView: true
                }
            }
        ]
    },
    {
        path: '/issues/:uuid',
        component: () => import('@/components/yuri-submenu/index.vue'),
        children: [
            {
                path: '',
                name: 'issues_uuid',
                component: () => import('@/views/issue-details/index.vue'),
                props: route => ({ id: route.params.uuid })
            },
            {
                path: 'view',
                name: 'issues_uuid_view',
                component: () => import('@/components/dynamic-view/index.vue'),
                props: route => ({ view: route.query.view, id: route.query.id }),
                meta: {
                    isView: true
                }
            }
        ]
    }
];
